import type { Identifier } from "ra-core";

import type { Contact, EmailRecipient } from "../types";

const capitalize = (value: string) =>
  value ? value.charAt(0).toUpperCase() + value.slice(1) : "";

/**
 * A new contact prefilled from the sender of an email: its name, or failing
 * that its address (« paul.martin@ » gives Paul Martin), and its company.
 */
export const contactDraftFromSender = (
  sender: EmailRecipient,
  companyId?: Identifier | null,
): Partial<Contact> => {
  const name = (sender.name ?? "").trim().replace(/^"|"$/g, "");
  const [first = "", ...rest] = name
    ? name.split(/\s+/)
    : sender.email.split("@")[0].split(".");
  return {
    first_name: capitalize(first),
    last_name: capitalize(rest.join(" ")),
    email_jsonb: [{ email: sender.email, type: "Work" }],
    ...(companyId != null
      ? { company_id: companyId, company_ids: [companyId] }
      : {}),
  };
};
